export default __webpack_public_path__ + "static/media/LDAY.41020da3.jpg";